import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Layout, Button, Input, Space, message } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { login } from '../../api/auth';
import { useAtom, useSetAtom } from 'jotai';
import { loggedInUserAtom } from '../../store/userAtom';


const { Header, Content } = Layout;

const headerStyle = {
    textAlign: 'center',
    color: '#fff',
    height: 64,
    paddingInline: 48,
    lineHeight: '64px',
    backgroundColor: '#ED4948',
};
const contentStyle = {
    textAlign: 'center',
    padding: '10px',
    minHeight: 120,
    lineHeight: '35px',
    color: '#000',
};
const footerStyle = {
    textAlign: 'center',
    color: '#fff',
    backgroundColor: '#4096ff',
};

const Login = () => {
  const [loggedInUser, setLoggedInUser] = useAtom(loggedInUserAtom);
    const [loading, setLoading] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();
    const [passwordVisible, setPasswordVisible] = React.useState(false);
    const [formData, setFormData] = useState({ username: '', password: '' })
    const navigate = useNavigate();


     // 使用useMemo缓存计算结果，当loggedInUser更新时重新计算，保证结果实时性
      const isAdmin = React.useMemo(() => {
        return loggedInUser?.admin || loggedInUser?.super_admin;
      }, [loggedInUser]);
    
      const isSuperAdmin = React.useMemo(() => {
        return loggedInUser?.super_admin;
      }, [loggedInUser]);

    const handleChange = (e) => {
        setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
    };
    const handleSubmit = async (e) => {
        setLoading(true);
        e.preventDefault();
        try {
            const resp = await login(formData);
            const info = { ...resp.data.token, admin: resp.data.token.is_admin, super_admin: resp.data.token.is_super_admin }
            setLoggedInUser(info);
            const windowWidth = window.innerWidth;
            console.log('windowWidth', windowWidth)
            // 移动端访问移动端的页面
            if(!info.admin && !info.super_admin) {
                navigate('/my-shop');
            }else {
                navigate('/home')
            }
        } catch (error) {
            if (error.response) {
                if (error.response.status === 401) {
                    messageApi.error('登录失败，用户名或密码错误');
                } else {
                    messageApi.error(`请求失败，状态码: ${error.response.status}`);
                }
            } else if (error.request) {
                messageApi.error('网络错误，请检查网络连接');
            } else {
                messageApi.error('请求错误: ' + error.message);
            }
            console.error('登录失败:', error);
        }
        setLoading(false);
    };

    return (
        <div>
            {contextHolder}
            <Header style={headerStyle}>用户登录</Header>
            <Content style={contentStyle}>
                <Space direction="vertical">
                    <Input placeholder="请输入用户名"
                        prefix={<UserOutlined />}
                        value={formData.username}
                        name="username"
                        onChange={handleChange}
                    />
                    <Space direction="horizontal">
                        <Input.Password
                            placeholder="请输入密码"
                            visibilityToggle={{ visible: passwordVisible, onVisibleChange: setPasswordVisible }}
                            value={formData.password}
                            name="password"
                            onChange={handleChange}
                        />
                        <Button style={{ width: 80 }} onClick={() => setPasswordVisible(prevState => !prevState)}>
                            {passwordVisible ? 'Hide' : 'Show'}
                        </Button>
                    </Space>
                    <Button
                        style={{ background: '#ED4948', color: '#fff' }}
                        variant="solid" block
                        onClick={handleSubmit}
                        loading={loading}
                    >
                        登录
                    </Button>
                    <Space.Compact direction="horizontal" block>
                        <Button
                            style={{ color: '#ED4948' }}
                            variant="solid"
                            block
                            onClick={() => navigate('/register')}
                        >
                            用户注册
                        </Button>
                        <Button
                            style={{ color: '#ED4948' }}
                            variant="solid" block
                            onClick={() => navigate('/forget')}
                        >
                            忘记密码
                        </Button>
                    </Space.Compact>
                </Space>
            </Content>
            {/* <Footer style={footerStyle}>Footer</Footer> */}
        </div>
    )
};

export default Login;
